import {
    CLEAR_REQUEST,
    SET_SUCCESS_REQUEST,
    SET_ERROR_REQUEST,
    SET_ERROR_REQUEST_RESP,
    SET_SUCCESS_REQUEST_WITH_ID,
    REMOVE_REQUEST_ID,
} from 'redux/constants/Request';

export const setSuccessRequest = (msg) => {
    return {
        type: SET_SUCCESS_REQUEST,
        payload: msg,
    };
};
export const setSuccessRequestWithID = (msg, id) => {
    return {
        type: SET_SUCCESS_REQUEST_WITH_ID,
        payload: { msg, id },
    };
};

export const setErrorRequest = (msg) => {
    return {
        type: SET_ERROR_REQUEST,
        payload: msg,
    };
};
export const setErrorRequestRespStatus = (msg, status) => {
    return {
        type: SET_ERROR_REQUEST_RESP,
        payload: { msg, status },
    };
};

export const clearRequest = () => {
    return {
        type: CLEAR_REQUEST,
    };
};
export const removeRequestId = () => {
    return {
        type: REMOVE_REQUEST_ID,
    };
};
